import ApplicationController from '../application_controller';

function seriesPatronPreview(patronInicial) {
  let patron = patronInicial;

  const placeholders = patron.match(/\[[AM]+\]/g);
  if (placeholders) {
    const year = (new Date()).getFullYear().toString();
    const month = `0${((new Date()).getMonth() + 1)}`.slice(-2);

    let i = 0;
    while (i < placeholders.length) {
      patron = patron.replace(
        placeholders[i],
        placeholders[i].replace(/AAAA/g, year).replace(/AA/g, year.slice(-2)).replace(/MM/g, month)
      );
      i += 1;
    }
    patron = patron.replace(/\[|\]/g, '');
  }

  const asteriskMatch = patron.match(/\*+/);
  if (asteriskMatch) {
    patron = patron.replace(asteriskMatch[0], Array(asteriskMatch[0].length).join('0') + 1);
  }

  return patron;
}

/* global $ */
export default class extends ApplicationController {
  connect() {
    this.$element = $(this.element);
    this.$element.find('#gestion_economica_serie_forma_pago_id').on('change', (e) => {
      if (parseInt($(e.currentTarget).val(), 10) === 3) {
        this.$element.find('.gestion_economica_serie_cuenta_id').removeClass('hide');
      } else {
        this.$element.find('.gestion_economica_serie_cuenta_id').addClass('hide');
      }
    });

    this.$element.find('#filtro_gestion_economica_serie_forma_pago_id').on('change', (e) => {
      const cuentaId = this.$element.find('#filtro_gestion_economica_serie_cuenta_id');
      if (parseInt($(e.currentTarget).val(), 10) === 3) {
        cuentaId.parent().removeClass('hide');
      } else {
        cuentaId.parent().addClass('hide');
        cuentaId.find('option:selected').prop('selected', false);
      }
    });

    // Simulador de serie
    this.$element.find('#gestion_economica_serie_patron').on('keyup', function onKeyup() {
      const $this = $(this);
      const $preview = $this.siblings('.patron-preview');
      if ($.trim($this.val()) === '') {
        $preview.addClass('hide');
      } else {
        $preview.removeClass('hide');
        $preview.text(seriesPatronPreview($this.val()));
      }
    }).trigger('keyup');

    $('body').on('click', '.update-abono-state', function onClick() {
      const $this = $(this);
      // set_overlay($this.closest('.ibox.gestion_economica_series'));
      $.ajax({
        method: 'PATCH',
        url: $this.data('update-path'),
        // global: false,
      });
      return false;
    });
  }
}
